export default __webpack_public_path__ + "static/media/2.9bdd5cf4.jpg";